export const enum FerryFilterName {
  ArrivalTimeFilters = 'arrivalTimeFilters',
  CarrierFilters = 'carrierFilters',
  DepartureTimeFilters = 'departureTimeFilters',
}
